var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {},
    [
      _c("div", { staticClass: "common-title" }, [_vm._v("融资信息")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "page-main no-shadow",
          staticStyle: { "padding-bottom": "6px" }
        },
        [
          _c(
            "a-form-model",
            {
              staticClass: "common-form-inline",
              attrs: {
                model: _vm.fintData,
                "label-col": { span: 6 },
                "wrapper-col": { span: 16 }
              }
            },
            [
              _c(
                "a-row",
                [
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("银行名称：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(_vm._s(_vm.fintData.tenantNm))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("申请日期：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("dateFormat")(
                              _vm.fintData.applyDate,
                              "YYYY-mm-dd"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("申请编号：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(_vm._s(_vm.fintData.fncJrnlId))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("意向放款日期：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("dateFormat")(
                              _vm.fintData.expectDate,
                              "YYYY-mm-dd"
                            )
                          ) + " "
                        )
                      ]),
                      _c(
                        "span",
                        { staticClass: "text-color-orange text-size-12" },
                        [_vm._v(" 以实际放款为准")]
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("资金用途：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm.fintData.opin
                          ? _c("span", [_vm._v(_vm._s(_vm.fintData.opin))])
                          : _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm._f("dictFilter")(
                                    _vm.fintData.cptlTpCd,
                                    _vm.dict.useOfFunds
                                  )
                                )
                              )
                            ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("到期日期：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("dateFormat")(
                              _vm.fintData.goldList &&
                                _vm.fintData.goldList[0].exDay,
                              "YYYY-mm-dd"
                            )
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("还款方式：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(
                            _vm._f("rpMdCdTrans")(_vm.fintData.instmRepyTpCd)
                          )
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("融资金额：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(_vm._f("splitK")(_vm.fintData.thsFncAmt)) +
                            " 元"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("利率(%)：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(_vm._s(_vm.fintData.yrRate || 0))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("预估利息：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(_vm._f("splitK")(_vm.fintData.interest)) +
                            " 元"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("融资手续费率(%)：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(_vm._s(_vm.fintData.financingFeeRatio || 0))
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("预估融资手续费：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(_vm._f("splitK")(_vm.fintData.fee)) + " 元"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("平台服务费：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _vm._v(
                          _vm._s(_vm._f("splitK")(_vm.fintData.platformInt)) +
                            " 元"
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-col",
                    { staticClass: "text-item-box", attrs: { span: "12" } },
                    [
                      _c("span", { staticClass: "text-item" }, [
                        _vm._v("合计金额：")
                      ]),
                      _c("span", { staticClass: "text-val" }, [
                        _c("span", { staticClass: "fin-num" }, [
                          _vm._v(
                            _vm._s(_vm._f("splitK")(_vm.fintData.totalAmt))
                          )
                        ]),
                        _vm._v("\n            元 ")
                      ]),
                      _c(
                        "span",
                        { staticClass: "text-color-orange text-size-12" },
                        [_vm._v(" 以实际放款为准")]
                      )
                    ]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-title" }, [_vm._v("祺信信息")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table-common",
          staticStyle: { "margin-bottom": "16px" }
        },
        [
          _c("a-table", {
            staticClass: "no-scroll",
            attrs: {
              pagination: false,
              size: "middle",
              columns: _vm.columns,
              "row-key": function(record) {
                return record.id
              },
              "data-source": _vm.goldList,
              bordered: "",
              locale: { emptyText: "暂无数据" }
            },
            scopedSlots: _vm._u([
              {
                key: "gldAmt",
                fn: function(text) {
                  return [_vm._v(_vm._s(_vm._f("splitK")(text)))]
                }
              },
              {
                key: "exDay",
                fn: function(text) {
                  return [
                    _vm._v(_vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")))
                  ]
                }
              },
              {
                key: "canBeModified",
                fn: function(text) {
                  return [
                    _vm._v(
                      _vm._s(
                        _vm._f("gbCbmTrans")(_vm.fatherCheckGold.canBeModified)
                      )
                    )
                  ]
                }
              },
              {
                key: "oper",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.openGoldDetail(record)
                          }
                        }
                      },
                      [_vm._v("详情")]
                    )
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-title" }, [_vm._v("贸易资料")]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "table-common",
          staticStyle: { "margin-bottom": "16px" }
        },
        [
          _c("a-table", {
            attrs: {
              size: "middle",
              pagination: false,
              columns: _vm.tradeBackgroundColumns,
              "row-key": function(record) {
                return record.id
              },
              "data-source": _vm.tradeBackgroundData,
              bordered: "",
              locale: { emptyText: "暂无数据" }
            },
            scopedSlots: _vm._u([
              {
                key: "invoiceType",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("invoiceTypeFilter")(text)) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "invoiceNumber",
                fn: function(text, record) {
                  return [
                    _c(
                      "a",
                      {
                        on: {
                          click: function($event) {
                            return _vm.toInvoiceInfo(record)
                          }
                        }
                      },
                      [_vm._v(_vm._s(text))]
                    )
                  ]
                }
              },
              {
                key: "billTime",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm._f("dateFormat")(text, "YYYY-mm-dd")) +
                        "\n      "
                    )
                  ]
                }
              },
              {
                key: "invoiceAmountWithVat",
                fn: function(text) {
                  return [
                    _vm._v(
                      "\n        " + _vm._s(_vm._f("splitK")(text)) + "\n      "
                    )
                  ]
                }
              },
              {
                key: "contractNo",
                fn: function(text, record) {
                  return [
                    text
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.contractInfoOpen(record)
                              }
                            }
                          },
                          [_vm._v(_vm._s(text))]
                        )
                      : _c("span", [_vm._v("--")])
                  ]
                }
              },
              {
                key: "otherFile",
                fn: function(text, record) {
                  return [
                    record.uploaded
                      ? _c(
                          "a",
                          {
                            on: {
                              click: function($event) {
                                return _vm.toDeliveryCreate(record)
                              }
                            }
                          },
                          [_vm._v("查看")]
                        )
                      : _c("span", [_vm._v("--")])
                  ]
                }
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.relatedFileContents.length > 0,
              expression: "relatedFileContents.length > 0"
            }
          ]
        },
        [
          _c("div", { staticClass: "common-title" }, [_vm._v("其他资料")]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "page-main no-shadow" },
            _vm._l(_vm.relatedFileContents, function(file, index) {
              return _c(
                "div",
                { key: index, staticClass: "spaceBetween file-item" },
                [
                  _c("div", { staticClass: "spaceLeft" }, [
                    _c("div", { staticClass: "file-title small" }, [
                      file.required
                        ? _c("span", { staticClass: "text-color-orange" }, [
                            _vm._v("*")
                          ])
                        : _vm._e(),
                      _vm._v(
                        "\n            " + _vm._s(file.name) + "\n          "
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-color-blue" },
                      [
                        _c("fileUpload", {
                          ref: "fncRelatedFile",
                          refInFor: true,
                          attrs: {
                            accept: ".pdf,.PDF",
                            className: "fnc-file",
                            paramObj: _vm.relatedFileParam,
                            removeaction: true,
                            name: "file"
                          },
                          on: {
                            "update:paramObj": function($event) {
                              _vm.relatedFileParam = $event
                            },
                            "update:param-obj": function($event) {
                              _vm.relatedFileParam = $event
                            },
                            uploadOk: function($event) {
                              return _vm.uploadOkRelated($event, file)
                            },
                            beforeFileUpload: function($event) {
                              return _vm.beforeUploadRelated(
                                $event,
                                file,
                                index
                              )
                            }
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticStyle: { width: "30%" } }, [
                    file.template
                      ? _c(
                          "a",
                          {
                            attrs: { href: "javascript:void(0)" },
                            on: {
                              click: function($event) {
                                return _vm.fileDownload(file.template.url)
                              }
                            }
                          },
                          [_vm._v(_vm._s(file.template.name))]
                        )
                      : _vm._e()
                  ])
                ]
              )
            }),
            0
          )
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-title" }, [_vm._v("收款账户")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "page-main no-shadow" },
        [
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { staticClass: "text-item-box", attrs: { span: "12" } },
                [
                  _c("span", { staticClass: "text-item" }, [
                    _vm._v("账户名称：")
                  ]),
                  _c("span", { staticClass: "text-val" }, [
                    _vm._v(_vm._s(_vm.bindingAccountData.cstNm))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { staticClass: "text-item-box", attrs: { span: "12" } },
                [
                  _c("span", { staticClass: "text-item" }, [
                    _vm._v("开户银行：")
                  ]),
                  _c("span", { staticClass: "text-val" }, [
                    _vm._v(_vm._s(_vm.bindingAccountData.accBlngBnk))
                  ])
                ]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "a-row",
            [
              _c(
                "a-col",
                { staticClass: "text-item-box", attrs: { span: "12" } },
                [
                  _c("span", { staticClass: "text-item" }, [
                    _vm._v("账户账号：")
                  ]),
                  _c("span", { staticClass: "text-val" }, [
                    _vm._v(_vm._s(_vm.bindingAccountData.accNo))
                  ])
                ]
              ),
              _vm._v(" "),
              _c(
                "a-col",
                { staticClass: "text-item-box", attrs: { span: "12" } },
                [
                  _c("span", { staticClass: "text-item" }, [
                    _vm._v("大额行号：")
                  ]),
                  _c("span", { staticClass: "text-val" }, [
                    _vm._v(_vm._s(_vm.bindingAccountData.largeBankNo))
                  ])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "common-title" }, [_vm._v("相关协议")]),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.dict.bankListMap[_vm.feeData.bank] == "shanghai",
              expression: "dict.bankListMap[feeData.bank] == 'shanghai'"
            }
          ],
          staticClass: "page-main no-shadow",
          staticStyle: { "margin-bottom": "8px" }
        },
        [
          _c("div", { staticClass: "text-color-orange" }, [
            _vm._v(
              "\n      温馨提示：您在上银企业银行APP已签署如下协议。请在上银企业银行APP下载对应协议（pdf格式）并上传。\n    "
            )
          ]),
          _vm._v(" "),
          _vm._l(_vm.fileList, function(file, index) {
            return _c(
              "div",
              { key: index, staticClass: "spaceLeft file-item" },
              [
                _c("div", { staticClass: "file-title" }, [
                  _c("span", { staticClass: "text-color-orange" }, [
                    _vm._v("*")
                  ]),
                  _vm._v("《" + _vm._s(file.artcTtl) + "》\n      ")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "text-color-blue" },
                  [
                    _c("fileUpload", {
                      ref: "fncFile",
                      refInFor: true,
                      attrs: {
                        accept: ".pdf,.PDF",
                        className: "fnc-file",
                        paramObj: _vm.fileParam,
                        removeaction: true,
                        disabled: _vm.fileDisabled,
                        showList: _vm.showFileList(index),
                        name: "file"
                      },
                      on: {
                        "update:paramObj": function($event) {
                          _vm.fileParam = $event
                        },
                        "update:param-obj": function($event) {
                          _vm.fileParam = $event
                        },
                        uploadOk: function($event) {
                          return _vm.uploadOk($event, file)
                        },
                        handleFileRemove: function($event) {
                          return _vm.removeFile($event, file)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            )
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.fileListOnline.length > 0,
              expression: "fileListOnline.length > 0"
            }
          ],
          staticClass: "page-main no-shadow",
          staticStyle: { "margin-bottom": "8px" }
        },
        _vm._l(_vm.fileListOnline, function(file, index) {
          return _c("div", { key: index, staticClass: "spaceLeft file-item" }, [
            _c("div", { staticClass: "file-title" }, [
              _c("span", { staticClass: "text-color-orange" }, [_vm._v("*")]),
              _vm._v(" "),
              _c(
                "a",
                {
                  on: {
                    click: function($event) {
                      return _vm.showfileOnline(file)
                    }
                  }
                },
                [_vm._v("《" + _vm._s(file.artcTtl) + "》")]
              )
            ])
          ])
        }),
        0
      ),
      _vm._v(" "),
      _vm.isShowAgree
        ? _c(
            "a-checkbox",
            {
              model: {
                value: _vm.isAgreeFile,
                callback: function($$v) {
                  _vm.isAgreeFile = $$v
                },
                expression: "isAgreeFile"
              }
            },
            [
              _c(
                "span",
                {
                  class: { "agree-active": _vm.agreeActive && !_vm.isAgreeFile }
                },
                [_vm._v("已阅读，并同意以上所有协议")]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "a-modal",
        {
          attrs: {
            width: "400px",
            title: "祺信融资确认",
            visible: _vm.modalShowPay,
            maskClosable: false,
            footer: null
          },
          on: {
            cancel: function($event) {
              _vm.modalShowPay = false
            }
          }
        },
        [
          _vm.modalShowPay
            ? _c("financePasswordModal", {
                attrs: { modalData: _vm.modalData },
                on: { ok: _vm.modalOk, cancel: _vm.modalCancel }
              })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("financingGoldDetailModel", {
        ref: "finGoldPageDialog",
        attrs: { parentData: _vm.curRowGold },
        on: {
          "update:parentData": function($event) {
            _vm.curRowGold = $event
          },
          "update:parent-data": function($event) {
            _vm.curRowGold = $event
          }
        }
      }),
      _vm._v(" "),
      _c("invoiceInfo", {
        ref: "invoiceInfo",
        attrs: { readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("contractDialog", {
        ref: "contractInfo",
        attrs: { title: "匹配合同详情", readonly: true, info: _vm.curRow },
        on: {
          "update:info": function($event) {
            _vm.curRow = $event
          }
        }
      }),
      _vm._v(" "),
      _c("relatedFileDialog", { ref: "relatedFileDialog" }),
      _vm._v(" "),
      _c("serviceView", { ref: "serviceView" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1d41da54", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d41da54","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/circulation/gold-financing/gold-financing-steps/gold-financing-step3.vue
// module id = VV01
// module chunks = 1